import React, { FC } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface FooterProps {
  className?: string;
  children?: React.ReactNode;
  environmentLabel: string;
}

const StyledFooter = styled('footer')({
    '&.bui-footer-nav-wrapper': {
      backgroundColor: '#F8F9FA',
      borderTop: '0.25rem solid #ff612b !important', // Add orange border
      padding: '16px 24px',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: '60px',
      zIndex: 1000
    }
  });

const CopyrightText = styled(Typography)({
  '&.bui-footer-copy': {
    fontSize: '16px',
    color: '#6C757D',
    fontFamily: '"Optum Sans", Helvetica, Arial, sans-serif',
    position: 'absolute',
    left: '24px',
    bottom: '12px',
    whiteSpace: 'nowrap',
    lineHeight: '1.5'
  }
});


const ContentBox = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-end', // Aligns content to the right
    alignItems: 'center',
    height: '100%',
    position: 'absolute', // Add absolute positioning
    right: '24px', // Position from right
    top: '50%', // Center vertically
    transform: 'translateY(-50%)', // Perfect vertical centering
    marginRight: '24px',
    '& .env-button': {
        color: '#ffffff',
        padding: '4px',
        marginRight: '16px',
        fontSize: '14px',
        fontFamily: '"Optum Sans", Helvetica, Arial, sans-serif',
        fontWeight: 600
    },
    '& .date-time': {
        fontSize: '12.8px',
        fontFamily:  '"Frutiger", Arial, sans-serif',
        fontWeight: 400,
        padding: '8px 24px',
        borderRadius: '62.4375rem', // Updated to match BUI button shape
        display: 'inline-flex', // Changed to inline-flex for better alignment
        alignItems: 'center',
        marginLeft: '24px',
        height: '2rem', // Added fixed height
        '& .envLabel': {
            fontWeight: 600,
            marginRight: '0px'
        }
    },
    '& .color-default': {
      backgroundColor: '#008272',
    },
    '& .color-prod': {
      backgroundColor: '#ff612b',
    }
  });

const StyledContainer = styled(Container)({
  position: 'relative',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: '24px',
  paddingRight: '24px',
  maxWidth: '100% !important'
});

const Footer: FC<FooterProps> = ({ className, children, environmentLabel }) => {
  const currentYear = new Date().getFullYear();
  const currentDate = new Date().toLocaleDateString(); // or toLocaleString() for more details
  const currentTime = new Date().toLocaleTimeString('en-US', { hour12: false });
  const colorClass = environmentLabel.toLowerCase() == 'prod' ? 'color-prod' : 'color-default';
  return (
    <StyledFooter className="bui-footer-nav-wrapper">
      <StyledContainer>
        <CopyrightText className="bui-footer-copy">
          © {currentYear} All rights reserved.
        </CopyrightText>
        <ContentBox>
        <div className={"date-time " + colorClass}>
            <span className="env-button">{environmentLabel}</span>
            {/* Using no whitespace prevents unwanted gaps */}
            {currentDate} {currentTime}
          </div>
        </ContentBox>
      </StyledContainer>
    </StyledFooter>
  );
};

export default Footer;